import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconKey, IconCheck, IconEye, IconEyeOff, IconAlertTriangle } from '@tabler/icons-react';
import { AdminAuthCard, AuthMessage } from './AdminLogin';
import { useAdminSession, updatePassword } from '../lib/auth';
import './AdminLogin.css';

// /admin/reset - the "Forgot password?" email link lands here. Supabase signs the
// visitor in from the link, then they choose a new password.
export default function AdminResetPassword() {
  var navigate = useNavigate();
  var auth = useAdminSession();
  var _pw = useState('');
  var pw = _pw[0];
  var setPw = _pw[1];
  var _pw2 = useState('');
  var pw2 = _pw2[0];
  var setPw2 = _pw2[1];
  var _show = useState(false);
  var show = _show[0];
  var setShow = _show[1];
  var _busy = useState(false);
  var busy = _busy[0];
  var setBusy = _busy[1];
  var _error = useState(null);
  var error = _error[0];
  var setError = _error[1];
  var _done = useState(false);
  var done = _done[0];
  var setDone = _done[1];

  async function handleSubmit(e) {
    e.preventDefault();
    if (busy) return;
    setError(null);
    if (pw !== pw2) {
      setError('The two passwords don’t match. Please type the same password in both boxes.');
      return;
    }
    setBusy(true);
    var res = await updatePassword(pw);
    setBusy(false);
    if (res.error) setError(res.error);
    else setDone(true);
  }

  if (done) {
    return (
      <AdminAuthCard pageTitle="Password changed" heading="Password changed" icon={<IconCheck size={22} />}
        intro="Your new password is saved. Use it next time you sign in.">
        <button type="button" className="al-submit" onClick={function() { navigate('/admin'); }}>
          Go to the admin panel
        </button>
      </AdminAuthCard>
    );
  }

  if (auth.loading) {
    return (
      <div className="al-page"><p className="al-wait">{'Checking your link…'}</p></div>
    );
  }

  if (!auth.session) {
    return (
      <AdminAuthCard pageTitle="Link expired" heading="This link has expired" icon={<IconAlertTriangle size={22} />}
        intro="Reset links only work once and only for a short time. Go back to the sign-in screen, click &ldquo;Forgot password?&rdquo; and use the newest email.">
        <button type="button" className="al-submit" onClick={function() { navigate('/admin'); }}>
          Back to sign in
        </button>
      </AdminAuthCard>
    );
  }

  return (
    <AdminAuthCard pageTitle="Choose a new password" heading="Choose a new password" icon={<IconKey size={22} />}
      intro="Use at least 8 characters. A short sentence you will remember works well.">
      <form className="al-form" onSubmit={handleSubmit} noValidate>
        <div className="al-field">
          <label htmlFor="al-new">New password</label>
          <div className="al-pw">
            <input id="al-new" type={show ? 'text' : 'password'} autoComplete="new-password" value={pw}
              onChange={function(e) { setPw(e.target.value); }} autoFocus />
            <button type="button" className="al-pw-toggle" aria-label={show ? 'Hide passwords' : 'Show passwords'}
              onClick={function() { setShow(!show); }}>
              {show ? <IconEyeOff size={16} /> : <IconEye size={16} />}
            </button>
          </div>
        </div>
        <div className="al-field">
          <label htmlFor="al-new2">Type it again</label>
          <input id="al-new2" type={show ? 'text' : 'password'} autoComplete="new-password" value={pw2}
            onChange={function(e) { setPw2(e.target.value); }} />
        </div>
        <AuthMessage text={error} />
        <button type="submit" className="al-submit" disabled={busy}>
          {busy ? 'Saving…' : 'Save new password'}
        </button>
      </form>
    </AdminAuthCard>
  );
}
